import { useState } from "react";
import ICONS from "../../../assets/Icons";
import ReimbursementTransactionsViewAll from "../../../containers/Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import useCategories from "../../../utils/useCategories";
import CommonLayout from "../../_utils/CommonLayout";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import MediumImagePopup from "../../_utils/MediumImagePopup";
import TickerAnimation from "../../_utils/TickerAnimation";
import AdditionalDetailsPreviewMapper from "../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import DestinationReimbursement from "../DestinationReimbursement";
import SVGComponent from "../../_utils/SVGComponent";

const TxnConfirm = ({
  txnPayLoad,
  showSimilarModal,
  setShowSimilarModal,
  onForceCreate,
  queryParams,
  setTxnPayLoad,
  flow,
  previewImages,
  categoryIds,
}) => {
  console.log(categoryIds);
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [imageToShow, setImageToShow] = useState(false);
  const categoryMapper = useCategories();
  const allLabels = [
    ...new Set([
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
    ]),
  ];

  const normalizedCategories = Array.isArray(txnPayLoad?.mergeCategory)
    ? txnPayLoad.mergeCategory
        .map((cat) => {
          if (typeof cat === "string") return cat;
          if (typeof cat === "object" && cat !== null)
            return cat?.name || cat?.category || "";
          return "";
        })
        .map((cat) => cat.trim())
        .filter(Boolean)
    : [];
  const categoryIcon = categoryMapper(categoryIds[0]);
  console.log(categoryIcon);
  return (
    <>
      {showSimilarModal && (
        <div className="fixed z-z-index-modal top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle={"Similar transactions found"}
            headersubtext={
              "Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
            }
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => setShowSimilarModal(false)}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            confirmbtnrequired={true}
            isbottomSectionneed={true}
            bottomHeaderTextNeed={true}
            btnText="Proceed with caution"
            handleFunction={() => {
              setShowSimilarModal(false);
              onForceCreate();
            }}
            bottomHeaderText={"Proceed with creating this transaction?"}
          >
            <ReimbursementTransactionsViewAll
              bene_account_name={txnPayLoad?.bankAccountName || "NA"}
              bene_account_id={txnPayLoad?.beneAccountId || null}
              bene_account_confidential={txnPayLoad?.beneAccountId || null}
              onClose={() => {
                setShowSimilarModal(false);
              }}
              queryParams={queryParams}
              similarTxnType={"similarTxn"}
            />
          </LargePopupRedirect>
        </div>
      )}

      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={{ url: imageToShow }}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}
      <div
        className={`w-width-full Qlg:px-padding-base px-padding-md   max-w-tab-width-normal mx-auto`}
      >
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              txnPayLoad={txnPayLoad}
              setTxnPayLoad={setTxnPayLoad}
              page="confirm"
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <DestinationReimbursement
              txnPayLoad={txnPayLoad}
              setTxnPayLoad={setTxnPayLoad}
              page="confirm"
            />
          </div>

          <div className="flex flex-col gap-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={txnPayLoad}
            />
            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={txnPayLoad?.settleType}
            />
          </div>

          <div className="flex flex-col gap-gap-md">
            <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
              <p className="text-left text-base mb-margin-md text-text-primary">
                <span className="font-semibold">Maker's Comment</span>
                <span className="font-normal"> (Optional)</span>
              </p>

              <p className="text-text-primary text-font-md break-words ">
                {txnPayLoad.comment || "N/A"}
              </p>

              <p className="text-text-secondary text-font-xs font-normal mt-margin-xs">
                {"Comment"}
              </p>
            </div>

            {flow === "PayReimburseTxn" ? (
              <>
                <div className=" w-full bg-primary-card p-padding-md rounded-border-radius-md">
                  <div>
                    <p className=" text-font-md text-text-primary font-semibold">
                      Category
                    </p>
                  </div>
                  <div
                    className={`rounded-border-radius-md  flex mt-margin-md items-center relative z-z-index-base w-width-full`}
                    style={{ background: "var(--category-background)" }}
                  >
                    <div className=" p-padding-sm flex items-center justify-center rounded-l-border-radius-md">
                      <div className="flex-shrink-0">
                        <SVGComponent
                          color={categoryIcon.colour}
                          url={categoryIcon.url}
                          height={"var(--icon-lg)"}
                          width="var(--icon-lg)"
                        />
                      </div>
                    </div>

                    <div
                      className={`flex relative z-z-index-base 
                    bg-primary-nav
                   rounded-r-border-radius-md flex-1 items-center overflow-hidden`}
                    >
                      <div className="Qmd:w-width-xl w-width-md relative z-z-index-base flex flex-col gap-gap-xs items-center justify-between flex-1 pr-padding-md pl-padding-sm py-padding-sm transition-colors duration-animation-fast-s">
                        <p className="w-width-full text-text-primary font-semibold text-sm break-all mb-request-padding pt-padding-sm pr-padding-xs">
                          <TickerAnimation text={txnPayLoad.categories} />
                        </p>

                        <p
                          className="w-width-full text-text-primary text-xs pr-padding-xs break-all"
                          style={{
                            visibility: "hidden",
                          }}
                        >
                          <TickerAnimation text={txnPayLoad.categories} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="lg:max-w-[var(--create-box-width)]  w-width-full">
                  <CategorySelector
                    previewMode={true}
                    selectedCategory={txnPayLoad?.selectedCategory}
                    category={normalizedCategories}
                    IFSC={txnPayLoad?.bankAccountIFSC}
                    accountNumber={txnPayLoad?.bankAccountNo}
                    beneAccountId={txnPayLoad?.beneAccountId}
                    unassignCategories={[]}
                    unassignlength={[]}
                  />
                </div>
              </>
            )}
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
              <p className="text-left text-base mb-margin-md text-text-primary">
                <span className="font-semibold">Labels</span>
                <span className="font-normal"> (Optional)</span>
              </p>

              <p className="text-text-primary text-font-sm break-words lg:break-normal lg:whitespace-normal">
                {allLabels.length === GlobalConfiguration.lengthCheckZero ? (
                  <span>{TEXT?.NO_LABELS_ASSIGNED}</span>
                ) : (
                  allLabels.map((item, index) => (
                    <span key={index}>
                      {item}
                      {index <
                        allLabels.length - GlobalConfiguration.lengthCheckOne &&
                        ", "}
                    </span>
                  ))
                )}
              </p>

              <p className="text-text-secondary text-font-xs font-normal mt-margin-xs">
                {TEXT?.LABELS}
              </p>
            </div>
          </div>

          <div className="lg:max-w-[var(--create-box-width)] w-width-full mb-margin-md">
            <AdditionalDetailsPreviewMapper
              mappingData={txnPayLoad.mergeCategory}
              previewImages={previewImages}
              fileOnClick={(e) => {
                if (e.type === "file") {
                  return;
                }
                if (e.type === "image-url") {
                  setImageToShow(e.name);
                } else {
                  setImageToShow(previewImages[e.name]);
                }
                setOpenImageUrl(true);
              }}
            />
          </div>
        </CommonLayout>

        {/* <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div> */}
      </div>
    </>
  );
};

export default TxnConfirm;
